
require('./scss/price-card.scss');
import {mapGetters} from 'vuex';
import Button from '../shared/Button'
import ProductDetails from './ProductDetails';
import Accounting from '../../mixins/accounting';
import BookingsLang from '../../lang/bookings';
import PriceCardLocalisations from '../../lang/PriceCard';
import merge from 'lodash/merge';
import branding from '../../mixins/branding';
import Tooltip from '../shared/Tooltip';

export default {
    name: 'PriceCard',

    props: [
        'product',
        'vehicle',
        'buy',
        'labels',
        'selectedCurrency',
        'selectVehicle',
        'currencyIsChanging',
        'showTermsAndConditions',
        'user',
        'handleLogin',
        'upsellCardType',
        'vehicleExternalId',
        'selectedProductType',
        'loyaltyHigherThanPromo',
    ],

    i18n: merge(BookingsLang, PriceCardLocalisations),

    components: {
        'gm-button': Button,
        'gm-tooltip': Tooltip,
        ProductDetails
    },

    mixins: [Accounting, branding],

    computed: Object.assign(
        {
            bookNowLabel() {
                return this.labels.bookNow;
            },

            vehiclePrice() {
                return this.quoteHireDuration > 1
                  ? this.originalPricePerDay(this.product, this.quoteHireDuration)
                  : this.formatMoney(this.product.total_price, this.selectedCurrency.code);
            },
        },
        mapGetters({
            quoteHireDuration: 'quoteHireDuration',
        })
    ),

    watch:{
        quoteHireDuration: function(duration) {
            this.vehiclePricePerDay = this.originalPricePerDay(this.product, duration);
        }
    },

    data() {
        return {
            icons: {
                BAS: this.brandingImagesPath("/images/vehicle-listing/basic-badge.svg"),
                PLU: this.brandingImagesPath("/images/vehicle-listing/plus-badge.svg"),
                PRE: this.brandingImagesPath("/images/vehicle-listing/premium-badge.svg"),
                PMP: this.brandingImagesPath("/images/vehicle-listing/premium-plus-badge.svg")
            },
            productLabels: {
                BAS: "basic",
                PLU: "plus",
                PRE: "premium",
                PMP: "premium plus+"
            },
            keylessLoginRequired: KEYLESS_LOGIN_REQUIRED !== "false",
            vehiclePricePerDay: 0,
        };
    },

    methods: {
        returnToBooking() {
            this.$router.push({name: 'edit-booking', params: {booking: this.$route.params.booking}});
        },
    },

    template: `
    <div class="price-card">
        <h5 class="title text-center"><img :src="icons[product.type]" alt="" style="height:35px;"></h5>
        <product-details :upsellCardType="upsellCardType" :product="product" :currency-is-changing="currencyIsChanging" :show-terms-and-conditions="showTermsAndConditions" :vehicle="vehicle"></product-details>
        <div class="desktop-choose-product row m-0" v-if="product.is_available">
            <div v-if="keylessLoginRequired && !user && vehicle.is_drive_and_go" class="choose-product col-12" :class="product.type" @click="handleLogin();">
                {{ $t('bookings.login_register') }}
                <img :src="brandingImagesPath('/images/large-arrow-white.svg')" alt="right arrow white" v-if="product.type === 'PMP'">
                <img :src="brandingImagesPath('/images/large-arrow-green.svg')" alt="right arrow green" v-else>
            </div>
            <div v-if="(!keylessLoginRequired && product.is_available) || (user && vehicle.is_drive_and_go && product.is_available) || (!vehicle.is_drive_and_go && product.is_available)"
                 class="choose-product col-12"
                 @click="selectVehicle(vehicle, product.id);"
            >
                <button
                  class="btn btn-link-outline rounded-pill text-capitalize btn-main p-3"
                  v-if="vehicle.external_id === vehicleExternalId && selectedProductType === product.type"
                  @click="returnToBooking"
                >
                    {{ $t('PriceCard.current_choice') }}
                </button>

                <button
                  v-else-if="product.type === 'BAS'"
                  class="btn btn-link-outline rounded-pill text-capitalize btn-main p-3"
                >
                  {{ bookNowLabel }}
                </button>

                <button
                  v-else-if="product.type === 'PMP'"
                  class="btn btn-primary text-capitalize btn-pmp p-3"
                >
                  {{ bookNowLabel }}
                </button>

            </div>
        </div>
        <p class="row p-0 mb-0 price-card-total">
            <span class="col-12 p-0">
                <gm-tooltip :text="labels.loyaltyAppliedInsteadOfPromo" class="d-inline-block" click="enabled" v-if="loyaltyHigherThanPromo">
                    <i class="fa fa-info-circle text-brand"></i>
                </gm-tooltip>
                <strong class="original-amount" v-if="product.original_price && !currencyIsChanging">{{ originalPrice(product) }}</strong>
                <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
                <strong class="amount" v-else>{{ vehiclePrice }}</strong>
                <strong>{{ labels.extraPerDay }}</strong>
            </span>
        </p>
<gm-button
    top-right-radius="0"
    top-left-radius="0"
    :disabled="true"
    v-if="!product.is_available"
>
    {{ $t('PriceCard.minimum_age', { age: product.minimum_age }) }}
</gm-button>
    </div>`,
};
